const escapeHtml = (text) =>
  `${text}`
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const stripChatArtifacts = (text) =>
  `${text}`
    // OpenAI-style file citation blocks (private use area markers)
    .replace(/\uE200filecite\uE202[^\uE201]*\uE201/g, '')
    .replace(/[\uE000-\uF8FF]/g, '')
    .replace(/filecite\s*turn\d+file\d+/gi, '')
    .replace(/\bfilecite\b/gi, '')
    .replace(/\bturn\d+file\d+\b/gi, '')
    .replace(/[^\S\n]{2,}/g, ' ')
    .replace(/[^\S\n]+([.,!?;:])/g, '$1')
    .trim();

const formatInline = (text) =>
  escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

const formatChatMessage = (message) => {
  if (!message) return '';

  const lines = stripChatArtifacts(message).split('\n');
  const blocks = [];
  let listItems = [];
  let paragraphLines = [];

  const flushParagraph = () => {
    if (!paragraphLines.length) return;
    blocks.push(
      `<p>${paragraphLines.map((line) => formatInline(line)).join('<br />')}</p>`
    );
    paragraphLines = [];
  };

  const flushList = () => {
    if (!listItems.length) return;
    blocks.push(
      `<ul>${listItems
        .map((item) => `<li>${formatInline(item)}</li>`)
        .join('')}</ul>`
    );
    listItems = [];
  };

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (trimmed.startsWith('- ')) {
      flushParagraph();
      listItems.push(trimmed.slice(2));
      return;
    }

    if (!trimmed) {
      flushList();
      flushParagraph();
      return;
    }

    flushList();
    paragraphLines.push(trimmed);
  });

  flushList();
  flushParagraph();

  return blocks.join('');
};

export default formatChatMessage;
